import { useState } from "react";
import classes from "./Mainboard.module.scss";
import Topbar from "../Topbar/Topbar";
import GeneralBoard from "../../GeneralBoard/GeneralBoard";
import { useSelector } from "react-redux";

interface Props {
  children: any;
}
const Mainboard = ({ children }: Props) => {
  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.dataBoardWrapper}>{children}</div>
      </div>
    </>
  );
};

export default Mainboard;
